export const numerico = v => {
    const novoValor = v.replace(/\D/g, '');
    return novoValor;
};

export const emailValido = v => {
    // eslint-disable-next-line
    const regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (regexEmail.test(v)) {
        return true;
    }
    return false;
};

export const telefone = v => {
    let novoValor = v.replace(/\D/g, ''); // Remove tudo o que não é dígito
    novoValor = novoValor.replace(/^(\d\d)(\d)/g, '($1) $2'); // Coloca parênteses em volta dos dois primeiros dígitos
    novoValor = novoValor.replace(/(\d{5})(\d)/, '$1-$2'); // Coloca hífen entre o quarto e o quinto dígitos

    return novoValor;
};

export const numeroSemFormatacao = v => {
    return v.replace(/[^a-zA-Z0-9]/g, '');
};

export const imagemCodigoBarras = v => {
    const divisor = v.split(' ');
    let codigobarras = '';

    divisor.forEach(item => {
        codigobarras += item.substr(0, 11);
    });

    return codigobarras;
};
